webpackJsonp([1],{

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(509),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Profile__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Users__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_UserDetail__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_UserDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_UserDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_UserEdit__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_UserEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_UserEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_FirstLogin__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_FirstLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_FirstLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ForgotPassword__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ChangePassword__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ChangePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_ChangePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Configuration__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CUSTOM_store__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_routes__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CUSTOM_custom_modules_routes__ = __webpack_require__(410);


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = {
  mode: 'history',
  routes: [{
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Profile___default.a,
    meta: { requiresAuth: true, minRole: 1 }
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Users___default.a,
    meta: { requiresAuth: true, minRole: 3 }
  }, {
    path: '/user/view/:id',
    name: 'UserDetail',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_UserDetail___default.a,
    meta: { requiresAuth: true, minRole: 3 }
  }, {
    path: '/user/edit/:id',
    name: 'UserEdit',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_UserEdit___default.a,
    meta: { requiresAuth: true, minRole: 3 }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Login___default.a,
    meta: { requiresAuth: false }
  }, {
    path: '/signup/:pass?/:email?',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_FirstLogin___default.a,
    meta: { requiresAuth: false }
  }, {
    path: '/configuratie',
    name: 'Configuratie',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Configuration___default.a,
    meta: { requiresAuth: true, minRole: 4 }
  }, {
    path: '/wachtwoord-vergeten',
    name: 'ForgotPassword',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_ForgotPassword___default.a,
    meta: { requiresAuth: false }
  }, {
    path: '/wachtwoord-veranderen',
    name: 'ChangePassword',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_ChangePassword___default.a,
    meta: { requiresAuth: false, minRole: 1 }
  }]
};
routes.routes.push.apply(routes.routes, __WEBPACK_IMPORTED_MODULE_14__modules_routes__["a" /* coreRoutes */]);
routes.routes.push.apply(routes.routes, __WEBPACK_IMPORTED_MODULE_15__CUSTOM_custom_modules_routes__["a" /* variableRoutes */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */](routes);

router.beforeEach(function (to, from, next) {
  // IF USER WANTS TO NAVIGATE AWAY FROM SIGNUP
  // ONLY ALLOW IF LINK IS NOT VALID --> USER IS NOT LOGGED IN
  if (!to.matched.length) {
    next('/');
  } else {
    next();
  }
  if (from.name === 'Signup') {
    if (__WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["a" /* auth */].currentUser) {
      __WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["b" /* db */].doc('users/' + __WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.uid).get().then(function (snap) {
        if (snap.data().firstLogin) {
          next(false);
        } else {
          next();
        }
      });
    } else {
      next();
    }
  }
  // CHECK IF PAGE REQUIRES AUTHENTICATION
  else if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    })) {
      // CHECK IF USER IS LOGGED IN
      if (__WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["a" /* auth */].currentUser) {
        // CHECK IF USER IS SAVED IN STORE
        if (!__WEBPACK_IMPORTED_MODULE_13__CUSTOM_store__["a" /* default */].state.user) {
          // GET USER FROM DATABASE
          __WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["b" /* db */].doc('users/' + __WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.uid).get().then(function (snap) {
            if (snap.data().firstLogin) {
              next({ path: 'signup' });
            } else {
              __WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["b" /* db */].doc('users-secure/' + __WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.uid).get().then(function (s) {
                if (s.data().role >= to.meta.minRole) {
                  next();
                } else {
                  next({ path: 'login' });
                }
              });
            }
          });
        } else {
          if (__WEBPACK_IMPORTED_MODULE_13__CUSTOM_store__["a" /* default */].state.user.firstLogin) {
            next({ path: 'signup' });
          } else if (__WEBPACK_IMPORTED_MODULE_13__CUSTOM_store__["a" /* default */].state.user.role >= to.meta.minRole) {
            next();
          } else {
            next({ path: 'login' });
          }
        }
      } else {
        next({ path: 'login' });
      }
    } else {
      if (to.fullPath == "/login" && __WEBPACK_IMPORTED_MODULE_12__CUSTOM_helpers_firebase__["a" /* auth */].currentUser) {
        next({ path: '/' });
      } else {
        next();
      }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_store__ = __webpack_require__(408);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  modules: {
    core: __WEBPACK_IMPORTED_MODULE_2__CORE_store__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(517),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rtdb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return storageRef; });
/* unused harmony export app */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_firestore__);



var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
    apiKey: "AIzaSyDz3aUg4RubtSpN1ZKIXtpX8N0bm-VbLXk",
    authDomain: "stand-up-149609.firebaseapp.com",
    databaseURL: "https://stand-up-149609.firebaseio.com",
    projectId: "stand-up-149609",
    storageBucket: "stand-up-149609.appspot.com",
    messagingSenderId: "64799192051"
});

// Export the database for components to use.
// If you want to get fancy, use mixins or provide / inject to avoid redundant imports.
var rtdb = firebaseApp.database();
var db = firebaseApp.firestore();
var auth = firebaseApp.auth();
var storage = firebaseApp.storage();
var storageRef = firebaseApp.storage().ref();
var app = firebaseApp;

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blogRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overview__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditBlogPost__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditBlogPost___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EditBlogPost__);



var blogRoutes = [{
  path: '/blog',
  name: 'Blog posts',
  component: __WEBPACK_IMPORTED_MODULE_0__Overview___default.a,
  meta: { requiresAuth: true, minRole: 1 }
}, {
  path: '/blog/:id',
  name: 'EditBlogPost',
  component: __WEBPACK_IMPORTED_MODULE_1__EditBlogPost___default.a,
  meta: { requiresAuth: true, minRole: 2 }
}];

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contactRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overview__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Overview__);


var contactRoutes = [{
  path: '/contact',
  name: 'Contact',
  component: __WEBPACK_IMPORTED_MODULE_0__Overview___default.a,
  meta: { requiresAuth: true, minRole: 1 }
}];

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overview__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Overview__);


var mediaRoutes = [{
  path: '/media',
  name: 'Media',
  component: __WEBPACK_IMPORTED_MODULE_0__Overview___default.a,
  meta: { requiresAuth: true, minRole: 1 }
}];

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pageRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pages__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Pages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageEdit__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PageEdit__);



var pageRoutes = [{
  path: '/',
  name: 'Pages',
  component: __WEBPACK_IMPORTED_MODULE_0__Pages___default.a,
  meta: { requiresAuth: true, minRole: 1 }
}, {
  path: '/pages',
  name: 'Pages',
  component: __WEBPACK_IMPORTED_MODULE_0__Pages___default.a,
  meta: { requiresAuth: true, minRole: 1 }
}, {
  path: '/page/:id',
  name: 'PageEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__PageEdit___default.a,
  meta: { requiresAuth: true, minRole: 2 }
}];

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return coreRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_PAGES_routes__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_MEDIA_routes__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_CONTACT_routes__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_BLOG_routes__ = __webpack_require__(403);






var r = [];

r.push.apply(r, __WEBPACK_IMPORTED_MODULE_0__modules_PAGES_routes__["a" /* pageRoutes */]);
r.push.apply(r, __WEBPACK_IMPORTED_MODULE_1__modules_MEDIA_routes__["a" /* mediaRoutes */]);
r.push.apply(r, __WEBPACK_IMPORTED_MODULE_2__modules_CONTACT_routes__["a" /* contactRoutes */]);
r.push.apply(r, __WEBPACK_IMPORTED_MODULE_3__modules_BLOG_routes__["a" /* blogRoutes */]);

var coreRoutes = r;

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_router__ = __webpack_require__(107);




var state = {
  user: null,
  loading: true,
  version: 'beta 0.0.3',
  config: null
};

var mutations = {
  SET_USER_MUTATION: function SET_USER_MUTATION(state, user) {
    state.user = user;
  },
  SET_LOADING: function SET_LOADING(state, s) {
    state.loading = s;
  },
  SET_CONFIG_DATA: function SET_CONFIG_DATA(state, c) {
    state.config = c;
  }
};

var actions = {
  SET_USER: function SET_USER(_ref, user) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    dispatch('LOAD_CONFIG');
    var u = {};
    __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].doc('users/' + user.uid).get().then(function (snap) {
      u = snap.data();
      u.uid = user.uid;
      __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].doc('users-secure/' + user.uid).get().then(function (s) {
        u.role = s.data().role;
        user.providerData.forEach(function (d) {
          if (d.providerId == 'facebook.com') {
            u.photoURL = "https://graph.facebook.com/" + d.uid + "/picture?height=50";
          }
        });
        commit('SET_USER_MUTATION', u);
        dispatch('IS_LOADING', false);
      });
    });
  },
  LOAD_CONFIG: function LOAD_CONFIG(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('preferences').onSnapshot(function (snap) {
      var config = {};
      snap.forEach(function (doc) {
        config[doc.id] = doc.data();
      });
      commit('SET_CONFIG_DATA', config);
    });
  },
  UNSET_USER: function UNSET_USER(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('SET_USER_MUTATION', null);
    dispatch('IS_LOADING', false);
  },
  IS_LOADING: function IS_LOADING(_ref4, s) {
    var commit = _ref4.commit;

    commit('SET_LOADING', s);
  },
  PUSH_NOTIFICATION: function PUSH_NOTIFICATION(_ref5, notif) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    UIkit.notification({ message: notif.message, status: notif.status });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Projects__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectEdit__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProjectEdit__);



var projectRoutes = [{
  path: '/projects',
  name: 'Projects',
  component: __WEBPACK_IMPORTED_MODULE_0__Projects___default.a,
  meta: { requiresAuth: true, minRole: 1 }
}, {
  path: '/project/:id',
  name: 'ProjectEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__ProjectEdit___default.a,
  meta: { requiresAuth: true, minRole: 2 }
}];

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return variableRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PROJECTS_routes__ = __webpack_require__(409);

var r = [];

r.push.apply(r, __WEBPACK_IMPORTED_MODULE_0__PROJECTS_routes__["a" /* projectRoutes */]);
var variableRoutes = r;

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_App__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CORE_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_router__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CORE_styles_main_scss__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CORE_styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CORE_styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CUSTOM_store__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vueditor__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vueditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vueditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vueditor_dist_style_vueditor_min_css__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vueditor_dist_style_vueditor_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vueditor_dist_style_vueditor_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var config = {
  fontName: [{ val: 'decalotyperegular' }, { val: 'akrobatlight' }, { val: 'open_sansbold' }],
  fontSize: ['12px', '14px', '16px', '18px', '0.8rem', '1.0rem', '1.2rem', '1.5rem', '2.0rem'],
  uploadUrl: ''
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vueditor___default.a, config);

/* eslint-disable no-new */

var unsubscribe = __WEBPACK_IMPORTED_MODULE_4__CUSTOM_helpers_firebase__["a" /* auth */].onAuthStateChanged(function (user) {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__CORE_router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__CORE_App___default.a },
    store: __WEBPACK_IMPORTED_MODULE_6__CUSTOM_store__["a" /* default */],
    created: function created() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__CUSTOM_helpers_firebase__["a" /* auth */].onAuthStateChanged(function (user) {
        if (user) {
          _this.$store.dispatch('SET_USER', user);
        } else {
          _this.$store.dispatch('UNSET_USER');
        }
      });
    }
  });
  unsubscribe();
});

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CORE_components_AppHeader__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CORE_components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CORE_components_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CUSTOM_components_SideMenu__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CUSTOM_components_SideMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CUSTOM_components_SideMenu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { AppHeader: __WEBPACK_IMPORTED_MODULE_0__CORE_components_AppHeader___default.a, SideMenu: __WEBPACK_IMPORTED_MODULE_1__CUSTOM_components_SideMenu___default.a },
  data: function data() {
    return {
      isLoading: true
    };
  },

  methods: {
    toggleLoading: function toggleLoading(l) {
      this.$store.dispatch('IS_LOADING', l);
    }
  }
});

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AppHeader',
    methods: {
        logout: function logout() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].signOut().then(function (success) {
                _this.$router.push('/login');
            });
        }
    }
});

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_ImageUploader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_ImageUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_ImageUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CORE_modules_MEDIA_imagePicker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CORE_modules_MEDIA_imagePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CORE_modules_MEDIA_imagePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'EditBlogPost',
    components: { imageUploader: __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_ImageUploader___default.a, imagePicker: __WEBPACK_IMPORTED_MODULE_3__CORE_modules_MEDIA_imagePicker___default.a },
    data: function data() {
        return {
            categories: null,
            blog: {
                title: null,
                content: '',
                categories: [],
                gallery: []
            },
            newCategory: null,
            editing: false
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('categories').doc('all').get().then(function (doc) {
            _this.categories = doc.data();
        }).catch(function (error) {
            console.log(error);
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$refs.editor.setContent(this.blog.content);
        if (this.$route.params.id != 0) {
            this.editing = true;
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('blogposts').doc(this.$route.params.id).onSnapshot(function (snap) {
                _this2.blog = snap.data();
                _this2.$refs.editor.setContent(_this2.blog.content);
            });
        }
    },

    methods: {
        update: function update() {
            var _this3 = this;

            this.blog.lastEdit = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore.FieldValue.serverTimestamp() || Math.floor(Date.now() / 1000);
            this.blog.content = this.$refs.editor.getContent();
            if (this.$route.params.id == 0) {
                this.blog.author = {
                    name: this.$store.state.core.user.displayName,
                    photoURL: this.$store.state.core.user.photoURL || ''
                };
                this.blog.created = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore.FieldValue.serverTimestamp() || Math.floor(Date.now() / 1000);
                __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('blogposts').doc(this.blog.title.toLowerCase().split(' ').join('-')).set(this.blog, { merge: true }).then(function (r) {
                    _this3.$store.dispatch('PUSH_NOTIFICATION', { message: 'Blogpost toegevoegd', status: 'success' });
                    _this3.$router.push('/blog');
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('blogposts').doc(this.$route.params.id).update(this.blog).then(function (r) {
                    _this3.$store.dispatch('PUSH_NOTIFICATION', { message: 'Blogpost aangepast', status: 'success' });
                    _this3.$router.push('/blog');
                });
            }
        },
        convertDate: function convertDate(timestamp) {
            return moment.unix(timestamp).fromNow();
        },
        uploaded: function uploaded(files) {
            var _this4 = this;

            files.forEach(function (f) {
                _this4.blog.gallery.push({ text: null, file: f, cover: false });
            });
        },
        removeImage: function removeImage(i) {
            this.blog.gallery.splice(i, 1);
        },
        addCategory: function addCategory() {
            this.blog.categories.push(this.categories[this.newCategory]);
        },
        removeCategory: function removeCategory(key) {
            this.blog.categories.splice(key, 1);
        },
        choose: function choose(images) {
            for (var i in images) {
                var img = images[i];
                this.blog.gallery.push({ key: i, description: img.description, url: img.url, medium: img.medium, large: img.large, extralarge: img.extralarge, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title });
            }
        }
    }
});

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_imagePicker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_imagePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_imagePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_VueImage__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_VueImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_VueImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Projects',
    components: { imagePicker: __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_imagePicker___default.a, VueImage: __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_VueImage___default.a },
    data: function data() {
        return {
            blogposts: null,
            categories: null
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('blogposts').onSnapshot(function (snap) {
            _this.blogposts = {};
            snap.forEach(function (doc) {
                _this.blogposts[doc.id] = doc.data();
            });
        });
        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('categories').doc('all').get().then(function (doc) {
            _this.categories = doc.data();
        }).catch(function (error) {
            console.log(error);
        });
    },

    methods: {
        convertDate: function convertDate(timestamp) {
            return moment(timestamp).fromNow();
        },
        remove: function remove(key) {
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('blogposts').doc(key).delete();
        }
    }
});

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Contact',
    data: function data() {
        return {
            contact: null
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('contact').onSnapshot(function (snap) {
            _this.contact = {};
            snap.forEach(function (doc) {
                _this.contact[doc.id] = doc.data();
            });
        });
    },

    methods: {
        remove: function remove(id) {
            UIkit.modal.confirm('Ben je zeker dat je dit bericht wil verwijderen?').then(function () {
                return __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('contact').doc(id).delete().then(function () {
                    UIkit.notification({ message: 'Bericht Verwijderd', status: 'danger' });
                });
            });
        }
    }
});

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'imageUploader',
    props: {
        showForm: {
            default: false,
            type: Boolean
        }
    },
    data: function data() {
        return {
            files: [],
            loaded: [],
            URLS: {},
            status: {},
            uploaded: 0
        };
    },

    methods: {
        upload: function upload(file, index) {
            var _this = this;

            var id = Math.floor(Math.random() * 90 + 10).toString();
            var extention = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
            var name = file.name.slice(0, -(extention.length + 1)) + "_" + id + '.' + extention;
            var uploadTask = __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["c" /* storageRef */].child('uploads/' + name).put(file);
            uploadTask.on('state_changed', function (snap) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this.loaded, index, snap.bytesTransferred / snap.totalBytes * 100);
            }, function (error) {
                throw error;
            }, function (res) {
                __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('media').add({ url: uploadTask.snapshot.downloadURL, alt: "", title: "", caption: "", description: "", uploaded: Math.floor(Date.now() / 1000) }).then(function (success) {
                    _this.uploaded++;
                    _this.files.splice(index, 1);
                    _this.URLS[success.id] = { url: uploadTask.snapshot.downloadURL, alt: "", title: "", caption: "", description: "" };
                    var metadata = {
                        customMetadata: {
                            'mediaId': success.id
                        }
                    };
                    __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["c" /* storageRef */].child('uploads/' + name).updateMetadata(metadata).then(function (res) {
                        _this.$store.dispatch('PUSH_NOTIFICATION', { message: 'Afbeelding upgeload', status: 'success' });
                        console.log(success.id);
                    }).catch(function (error) {
                        console.log('error updating metadata');
                        throw error;
                    });
                    if (_this.uploaded == _this.files.length) {
                        _this.$emit('uploaded', _this.URLS);
                    }
                }).catch(function (error) {
                    console.log(error);
                    __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["c" /* storageRef */].child('media/' + file.name).delete().then(function (succ) {
                        console.log('removed image due to an error');
                    }).catch(function (error) {
                        console.log('unable to remove image after error.');
                        console.log('error');
                    });
                });
            });
        },
        select: function select(event) {
            var _this2 = this;

            Array.prototype.forEach.call(event.target.files, function (file) {
                _this2.files.push(file);
                _this2.upload(file, _this2.files.length - 1);
            });
        },
        saveInfo: function saveInfo(i) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.status, i, 'Saving...');
            __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('media').doc(i).update(this.URLS[i]).then(function (success) {
                console.log('info updated');
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this3.status, i, 'Saved!');
            });
        }
    }
});

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_ImageUploader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_ImageUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_ImageUploader__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MediaOverview',
    components: { imageUploader: __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_ImageUploader___default.a },
    data: function data() {
        return {
            media: null,
            selected: null,
            formats: ['placeholder', 'small', 'medium', 'large', 'extralarge', 'url']
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('media').onSnapshot(function (snap) {
            _this.media = {};
            snap.forEach(function (doc) {
                _this.media[doc.id] = doc.data();
            });
        });
    },

    methods: {
        select: function select(id) {
            this.selected = id;
        },
        save: function save() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('media').doc(this.selected).update(this.media[this.selected]).then(function (success) {
                _this2.$store.dispatch('PUSH_NOTIFICATION', { message: 'Afbeelding data aangepast', status: 'success' });
                _this2.selected = null;
            }).catch(function (error) {
                throw error;
            });
        },
        deleteImage: function deleteImage(id) {
            var _this3 = this;

            if (this.$store.state.core.user.role >= 3) {
                UIkit.modal.confirm('Ben je zeker dat je deze foto wil verwijderen?').then(function () {
                    var promise = [];
                    for (var f in _this3.formats) {
                        if (__WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["d" /* storage */].refFromURL(_this3.media[id][_this3.formats[f]])) {
                            promise.push(__WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["d" /* storage */].refFromURL(_this3.media[id][_this3.formats[f]]).delete());
                        }
                    }
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promise).then(function (success) {
                        _this3.selected = null;
                        return __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('media').doc(id).delete();
                    }).then(function (success) {
                        _this3.$store.dispatch('PUSH_NOTIFICATION', { message: 'Foto verwijderd', status: 'danger' });
                    }).catch(function (error) {
                        _this3.$store.dispatch('PUSH_NOTIFICATION', { message: 'Er ging iets fout...', status: 'danger' });
                        throw error;
                    });
                }, function () {
                    console.log('Rejected.');
                });
            }
        },
        deleteProcessingImage: function deleteProcessingImage(id) {
            var _this4 = this;

            if (this.$store.state.core.user.role >= 3) {
                UIkit.modal.confirm('Deze foto is nog aan het verwerken, ben je zeker dat je dit wilt annuleren?').then(function () {
                    var promise = [];
                    var m = _this4.media[id];
                    for (var f in _this4.formats) {
                        if (m[f] != undefined && __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["d" /* storage */].refFromURL(_this4.media[id][_this4.formats[f]])) {
                            promise.push(__WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["d" /* storage */].refFromURL(_this4.media[id][_this4.formats[f]]).delete());
                        }
                    }
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promise).then(function (success) {
                        return __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('media').doc(id).delete();
                    }).then(function (success) {
                        _this4.$store.dispatch('PUSH_NOTIFICATION', { message: 'Foto verwijderd', status: 'danger' });
                    }).catch(function (error) {
                        _this4.$store.dispatch('PUSH_NOTIFICATION', { message: 'Er ging iets fout...', status: 'danger' });
                        throw error;
                    });
                }, function () {
                    console.log('Rejected.');
                });
            }
        }
    }
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "VueImage",
    props: {
        img: {
            required: true
        },
        size: {
            required: false,
            default: 2
        }
    },
    computed: {
        images: function images() {
            if (this.img) {
                if (this.img.key) {
                    var res = {};
                    res[this.img.key] = this.img;
                    return res;
                } else {
                    return this.img;
                }
            } else {
                return null;
            }
        }
    }
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ImagePicker',
    props: {
        'multiple': {
            default: true
        }
    },
    data: function data() {
        return {
            media: null,
            componentID: null,
            selected: {}
        };
    },
    created: function created() {
        var _this = this;

        this.componentID = Math.floor(Math.random() * 100 + 1);

        __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('media').onSnapshot(function (snap) {
            _this.media = {};
            snap.forEach(function (doc) {
                _this.media[doc.id] = doc.data();
            });
        });
    },

    methods: {
        select: function select(id, m) {
            if (this.selected[id]) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(this.selected, id);
            } else {
                if (this.multiple) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.selected, id, m);
                } else {
                    this.selected = {};
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.selected, id, m);
                }
            }
        },
        choose: function choose() {
            this.$emit('choose', this.selected);
            this.selected = {};
        }
    }
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CORE_modules_MEDIA_imagePicker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CORE_modules_MEDIA_imagePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CORE_modules_MEDIA_imagePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CORE_modules_MEDIA_VueImage__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CORE_modules_MEDIA_VueImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CORE_modules_MEDIA_VueImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uikit__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uikit__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PageEdit',
    components: { imagePicker: __WEBPACK_IMPORTED_MODULE_3__CORE_modules_MEDIA_imagePicker___default.a, VueImage: __WEBPACK_IMPORTED_MODULE_4__CORE_modules_MEDIA_VueImage___default.a },
    data: function data() {
        return {
            page: null,
            sections: [],
            selectedSection: null,
            newSection: null,
            editing: false,
            currentType: 'text',
            newField: {
                name: null,
                value: null
            }
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.$route.params.id).onSnapshot(function (snap) {
            _this.page = snap.data();
        });
        __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.$route.params.id).collection('sections').orderBy("order").onSnapshot(function (snap) {
            _this.sections = {};
            snap.forEach(function (doc) {
                _this.sections[doc.id] = doc.data();
            });
        });
    },

    methods: {
        isImage: function isImage(field) {
            if (field.value.url || field.value[0].url) {
                return true;
            } else {
                return false;
            }
        },
        addSection: function addSection() {
            var _this2 = this;

            //TODO CHECK IF SECTION NAME EXSISTS!
            __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.$route.params.id).collection('sections').doc(this.newSection).set({ 'lastEdit': Math.floor(Date.now() / 1000), 'author': this.$store.state.core.user.uid, name: this.newSection, order: 1 + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.sections).length }).then(function () {
                _this2.$store.dispatch('PUSH_NOTIFICATION', { message: 'Section toegevoegd', status: 'success' });
                _this2.newSection = null;
                _this2.updateEditTimestamp();
            });
        },
        selectCurrentType: function selectCurrentType(type) {
            this.currentType = type;
            if (this.currentType == 'link') {
                this.newField.value = { url: '', text: '' };
            } else {
                this.newField.value = null;
            }
        },
        addField: function addField() {
            var _this3 = this;

            var order = 1;
            if (this.sections[this.selectedSection]['fields']) {
                order = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.sections[this.selectedSection]['fields']).length + 1;
            } else {
                this.sections[this.selectedSection]['fields'] = {};
            }
            this.newField.type = this.currentType;
            if (this.currentType == 'wysiwyg') {
                this.newField.value = this.$refs.editor.getContent();
            }
            this.sections[this.selectedSection]['fields'][this.newField.name] = { value: this.newField.value, type: this.newField.type, order: order, 'author': this.$store.state.core.user.uid, 'lastEdit': Math.floor(Date.now() / 1000) };
            __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.$route.params.id).collection('sections').doc(this.selectedSection).update(this.sections[this.selectedSection]).then(function (res) {
                _this3.$store.dispatch('PUSH_NOTIFICATION', { message: 'Veld toegepast', status: 'success' });
                _this3.newField = {
                    name: null,
                    value: null
                };
                _this3.currentType = 'text';
                _this3.selectedSection = null;
                _this3.editing = false;
                _this3.updateEditTimestamp();
            });
        },
        editField: function editField() {
            var _this4 = this;

            if (this.newField.type == 'wysiwyg') {
                this.newField.value = this.$refs.editor.getContent();
            }
            this.sections[this.selectedSection]['fields'][this.newField.name].value = this.newField.value;
            this.sections[this.selectedSection]['fields'][this.newField.name].lastEdit = Math.floor(Date.now() / 1000);
            this.sections[this.selectedSection]['fields'][this.newField.name].author = this.$store.state.core.user.uid;
            __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.$route.params.id).collection('sections').doc(this.selectedSection).update(this.sections[this.selectedSection]).then(function (res) {
                _this4.$store.dispatch('PUSH_NOTIFICATION', { message: 'Veld aangepast', status: 'success' });
                _this4.updateEditTimestamp();
                _this4.cancel();
            });
        },
        setSelectedSection: function setSelectedSection(id) {
            this.selectedSection = id;
        },
        cancel: function cancel() {
            this.editing = false;
            this.newField = {
                name: null,
                value: null
            };
        },
        setEdit: function setEdit(id, key, field) {
            var _this5 = this;

            this.selectedSection = id;
            this.editing = true;
            this.newField = {
                name: key,
                value: field.value,
                type: field.type
            };
            if (field.type == 'wysiwyg') {
                setTimeout(function () {
                    _this5.$refs.editor.setContent(field.value);
                }, 200);
            }
        },
        deleteSection: function deleteSection(id) {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.$route.params.id).collection('sections').doc(id).delete().then(function () {
                _this6.$store.dispatch('PUSH_NOTIFICATION', { message: 'Section verwijderd', status: 'danger' });
                _this6.updateEditTimestamp();
            });
        },
        deleteField: function deleteField(id, key) {
            var _this7 = this;

            delete this.sections[id]['fields'][key];
            __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.$route.params.id).collection('sections').doc(id).update(this.sections[id]).then(function () {
                _this7.$store.dispatch('PUSH_NOTIFICATION', { message: 'Veld verwijderd', status: 'danger' });
                _this7.updateEditTimestamp();
            });
        },
        updateEditTimestamp: function updateEditTimestamp() {
            __WEBPACK_IMPORTED_MODULE_2__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.$route.params.id).update({ lastEdit: Math.floor(Date.now() / 1000) });
        },
        choose: function choose(images) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(images).length > 1) {
                this.newField.value = [];
                for (var i in images) {
                    var img = images[i];
                    this.newField.value.push({ key: i, description: img.description, url: img.url, medium: img.medium, extralarge: img.extralarge || img.large, large: img.large, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title });
                }
            } else {
                for (var i in images) {
                    var img = images[i];
                    this.newField.value = { key: i, description: img.description, url: img.url, medium: img.medium, extralarge: img.extralarge || img.large, large: img.large, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title };
                }
            }
            if (this.editing) {
                this.editField();
            } else {
                this.addField();
            }
        }
    }
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Pages',
    data: function data() {
        return {
            pages: null,
            newPage: {
                name: null
            }
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').onSnapshot(function (snap) {
            _this.pages = {};
            snap.forEach(function (doc) {
                _this.pages[doc.id] = doc.data();
            });
        });
    },

    methods: {
        add: function add() {
            this.newPage.created = Math.floor(Date.now() / 1000);
            this.newPage.lastEdit = Math.floor(Date.now() / 1000);
            //TODO: CHECK IF PAGE NAME ALREADY EXSISTS
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('pages').doc(this.newPage.name).set(this.newPage);
        },
        cancel: function cancel() {
            this.newPage = {
                name: null
            };
        },
        convertDate: function convertDate(timestamp) {
            return moment.unix(timestamp).fromNow();
        }
    }
});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChangePassword',
    data: function data() {
        return {
            password: '',
            oldPassword: '',
            error: null,
            success: false,
            loading: false
        };
    },
    created: function created() {
        this.$emit('loading', false);
    },

    methods: {
        ChangePassword: function ChangePassword() {
            var _this = this;

            this.loading = true;
            var credential = __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"].EmailAuthProvider.credential(__WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.email, this.oldPassword);
            __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.reauthenticateWithCredential(credential).then(function () {
                return __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.updatePassword(_this.password);
            }).then(function () {
                _this.success = true;
                _this.loading = false;
            }).catch(function (error) {
                _this.loading = false;
                _this.error = error;
                if (error.code == 'auth/user-not-found') {
                    _this.success = true;
                }
            });
        }
    }
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CUSTOM_helpers_firebase__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Configuratie',
    data: function data() {
        return {
            preferences: null,
            loading: false
        };
    },

    methods: {
        update: function update() {
            var _this = this;

            this.loading = true;
            var promises = [];
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.preferences).forEach(function (k) {
                promises.push(__WEBPACK_IMPORTED_MODULE_3__CUSTOM_helpers_firebase__["b" /* db */].collection('preferences').doc(k).set(_this.preferences[k], { merge: true }));
            });
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (res) {
                _this.loading = false;
            }).catch(function (error) {
                _this.loading = false;
                throw error;
            });
        }
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_3__CUSTOM_helpers_firebase__["b" /* db */].collection('preferences').onSnapshot(function (snap) {
            _this2.preferences = {};
            snap.forEach(function (doc) {
                __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this2.preferences, doc.id, doc.data());
            });
            console.log(_this2.preferences);
            if (!_this2.preferences.generalData) {
                _this2.preferences.generalData = {};
            }
        });
    }
});

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChangePassword',
    data: function data() {
        return {
            newPassword: '',
            error: null,
            loggedIn: false,
            warning: false,
            loading: false
        };
    },
    created: function created() {
        var _this = this;

        if (this.$route.params.email && this.$route.params.pass) {
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].signOut();
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].signInWithEmailAndPassword(this.$route.params.email, this.$route.params.pass).then(function (auth) {
                _this.loggedIn = true;
            }).catch(function (error) {
                var errorCode = error.code;
                var errorMessage = error.message;
                _this.error = error;
            });
        } else {
            if (!__WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].currentUser) {
                this.$router.push('/login');
            } else {
                this.warning = true;
            }
        }
    },

    methods: {
        ChangePassword: function ChangePassword() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.updatePassword(this.newPassword).then(function (auth) {
                __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('users').doc(_this2.$store.state.core.user.uid).update({ firstLogin: false }).then(function (res) {
                    _this2.$store.state.core.user.firstLogin = false;
                    _this2.loading = false;
                    _this2.$router.push('/');
                });
            }).catch(function (error) {
                _this2.loading = false;
                var errorCode = error.code;
                var errorMessage = error.message;
                _this2.error = error;
                console.log(error);
            });
        },
        ChangeAccount: function ChangeAccount() {
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].signOut();
            this.$router.push('/login');
        }
    }

});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ForgotPassword',
    data: function data() {
        return {
            email: '',
            error: null,
            success: false,
            loading: false
        };
    },
    created: function created() {
        this.$emit('loading', false);
    },

    methods: {
        ForgotPassword: function ForgotPassword() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].sendPasswordResetEmail(this.email).then(function () {
                _this.success = true;
                _this.loading = false;
            }).catch(function (error) {
                _this.loading = false;
                _this.error = error;
                if (error.code == 'auth/user-not-found') {
                    _this.success = true;
                }
                // An error happened.
            });
        }
    }
});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            email: '',
            password: '',
            error: null,
            loading: false,
            errorMessages: {
                'auth/invalid-email': 'Gelieve een correct emailadres in te vullen',
                'auth/user-not-found': 'De combinatie van het email adres en wachtwoord klopt niet',
                'auth/wrong-password': 'De combinatie van het email adres en wachtwoord klopt niet'
            }
        };
    },
    created: function created() {
        this.$emit('loading', false);
    },

    methods: {
        login: function login() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].signInWithEmailAndPassword(this.email, this.password).then(function (auth) {
                _this.$router.push('/');
            }).catch(function (error) {
                _this.loading = false;
                var errorCode = error.code;
                var errorMessage = error.message;
                _this.error = error;
            });
        },
        loginFb: function loginFb() {
            var _this2 = this;

            var provider = new __WEBPACK_IMPORTED_MODULE_1_firebase__["auth"].FacebookAuthProvider();
            provider.setCustomParameters({
                'display': 'popup'
            });
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].signInWithPopup(provider).then(function (r) {
                return __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].doc('users/' + r.user.uid).get();
            }).then(function (u) {
                var user = u.data();
                _this2.$router.push('/');
                _this2.loading = false;
            }).catch(function (error) {
                if (__WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].currentUser) {
                    __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.delete();
                }
                _this2.loading = false;
                _this2.error = 'Kon niet aanmelden met Facebook. Controleer of je reeds een account hebt en deze gekoppeld is aan je Facebook Account';
            });
        }
    }
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var facebook = new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.FacebookAuthProvider();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Profile',
    methods: {
        linkFacebook: function linkFacebook() {
            __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.linkWithPopup(facebook).then(function (result) {
                var credential = result.credential;
                var user = result.user;
                return __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.uid).update({ facebookLinked: true });
            }).then(function () {
                console.log('done');
            }).catch(function (error) {
                console.log(error);
                if (error.code == 'auth/provider-already-linked') {
                    __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["a" /* auth */].currentUser.uid).update({ facebookLinked: true }).then(function () {});
                }
            });
        }
    }

});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'UserDetail',
    data: function data() {
        return {
            u: null
        };
    },

    methods: {
        update: function update() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('users').doc(this.$route.params.id).set(this.u).then(function (res) {
                _this.$router.push('/users');
            });
        }
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('users').doc(this.$route.params.id).onSnapshot(function (snap) {
            _this2.u = snap.data();
        });
    }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'UserDetail',
    data: function data() {
        return {
            u: null,
            role: null,
            loading: false,
            userRoles: ["Gebruiker", "Moderator", "Beheerder"]
        };
    },

    methods: {
        update: function update() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('users').doc(this.$route.params.id).update(this.u), __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('users-secure').doc(this.$route.params.id).update({ role: this.role + 1 })]).then(function (res) {
                _this.loading = false;
                _this.$router.push('/users');
            });
        }
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('users').doc(this.$route.params.id).onSnapshot(function (snap) {
            _this2.u = snap.data();
        });
        __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('users-secure').doc(this.$route.params.id).onSnapshot(function (snap) {
            _this2.role = snap.data().role - 1;
        });
        if (this.$store.state.core.user.role >= 4) {
            this.userRoles.push('Admin');
        }
    }
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'users',
    data: function data() {
        return {
            newInvite: {
                email: null,
                firstname: null,
                lastname: null,
                accepted: true
            },
            users: {},
            roles: {},
            newUsers: {},
            userRoles: ["Gebruiker", "Moderator", "Beheerder", "Admin"]
        };
    },

    methods: {
        invite: function invite() {
            __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('newUsers').add(this.newInvite);
            this.cancel();
        },
        cancel: function cancel() {
            this.newInvite = {
                email: null,
                firstname: null,
                lastname: null,
                phone: null,
                rrid: null
            };
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('users').onSnapshot(function (snap) {
            snap.forEach(function (doc) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this.users, doc.id, doc.data());
            });
        });
        __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('users-secure').onSnapshot(function (snap) {
            snap.forEach(function (doc) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this.roles, doc.id, doc.data());
            });
        });
        __WEBPACK_IMPORTED_MODULE_1__CUSTOM_helpers_firebase__["b" /* db */].collection('newUsers').onSnapshot(function (snap) {
            _this.newUsers = {};
            snap.forEach(function (doc) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this.newUsers, doc.id, doc.data());
            });
        });
    }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "sideMenu"
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_ImageUploader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_ImageUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_ImageUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_imagePicker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_imagePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_imagePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Projects',
    components: { imageUploader: __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_ImageUploader___default.a, imagePicker: __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_imagePicker___default.a },
    data: function data() {
        return {
            categories: null,
            project: {
                name: null,
                titel: null,
                info: null,
                link: {
                    url: null,
                    text: null
                },
                color: null,
                categories: {},
                gallery: []
            },
            newCategory: null,
            loading: false
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('categories').doc('all').get().then(function (doc) {
            _this.categories = doc.data();
        }).catch(function (error) {
            console.log(error);
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('projects').doc(this.$route.params.id).onSnapshot(function (snap) {
            _this2.project = snap.data();
            _this2.$refs.editor.setContent(_this2.project.info);
        });
    },

    methods: {
        update: function update() {
            var _this3 = this;

            this.loading = true;
            this.project.lastEdit = Math.floor(Date.now() / 1000);
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('projects').doc(this.$route.params.id).update(this.project).then(function (r) {
                _this3.$store.dispatch('PUSH_NOTIFICATION', { message: 'Project aangepast', status: 'success' });
                _this3.$router.push('/projects');
            });
        },
        cancel: function cancel() {
            this.newProject = {
                name: null
            };
        },
        convertDate: function convertDate(timestamp) {
            return moment.unix(timestamp).fromNow();
        },
        uploaded: function uploaded(files) {
            var _this4 = this;

            files.forEach(function (f) {
                _this4.project.gallery.push({ text: null, file: f, cover: false });
            });
        },
        removeImage: function removeImage(i) {
            this.project.gallery.splice(i, 1);
        },
        addCategory: function addCategory() {
            this.project.categories.push(this.categories[this.newCategory]);
        },
        removeCategory: function removeCategory(key) {
            this.project.categories.splice(key, 1);
        },
        choose: function choose(images) {
            for (var i in images) {
                var img = images[i];
                this.project.gallery.push({ key: i, description: img.description, url: img.url, medium: img.medium, large: img.large, extralarge: img.extralarge, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title });
            }
        }
    }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_imagePicker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_imagePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_imagePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_VueImage__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_VueImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_VueImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Projects',
    components: { imagePicker: __WEBPACK_IMPORTED_MODULE_1__CORE_modules_MEDIA_imagePicker___default.a, VueImage: __WEBPACK_IMPORTED_MODULE_2__CORE_modules_MEDIA_VueImage___default.a },
    data: function data() {
        return {
            projects: null,
            categories: null,
            newCategory: null,
            newProject: {
                name: null,
                titel: null,
                info: null,
                link: {
                    url: null,
                    text: null
                },
                color: null,
                categories: {},
                gallery: []
            }
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('projects').onSnapshot(function (snap) {
            _this.projects = {};
            snap.forEach(function (doc) {
                _this.projects[doc.id] = doc.data();
            });
        });
        __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('categories').doc('all').get().then(function (doc) {
            _this.categories = doc.data();
        }).catch(function (error) {
            console.log(error);
        });
    },

    methods: {
        add: function add() {
            this.newProject.created = Math.floor(Date.now() / 1000);
            this.newProject.lastEdit = Math.floor(Date.now() / 1000);
            this.newProject.info = this.$refs.editor.getContent();
            //TODO: CHECK IF PROJECT NAME ALREADY EXSISTS
            __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('projects').doc(this.newProject.name.toLowerCase().split(' ').join('-')).set(this.newProject);
        },
        cancel: function cancel() {
            this.newProject = {
                name: null,
                titel: null,
                info: null,
                link: {
                    url: null,
                    text: null
                },
                color: null,
                categories: {},
                gallery: []
            };
        },
        addCategory: function addCategory() {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(this.newProject.categories, this.newCategory, this.categories[this.newCategory]);
        },
        removeCategory: function removeCategory(key) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].delete(this.newProject.categories, key);
        },
        convertDate: function convertDate(timestamp) {
            return moment.unix(timestamp).fromNow();
        },
        choose: function choose(images) {
            for (var i in images) {
                var img = images[i];
                this.newProject.gallery.push({ key: i, description: img.description, url: img.url, extralarge: img.extralarge, medium: img.medium, large: img.large, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title });
            }
            setTimeout(function () {
                UIkit.modal("#page-modal").show();
            }, 200);
        },
        remove: function remove(id) {
            UIkit.modal.confirm('Ben je zeker dat je dit project wil verwijderen?').then(function () {
                return __WEBPACK_IMPORTED_MODULE_0__CUSTOM_helpers_firebase__["b" /* db */].collection('projects').doc(id).delete().then(function () {
                    UIkit.notification({ message: 'Project Verwijderd', status: 'danger' });
                });
            });
        }
    }
});

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 169,
	"./af.js": 169,
	"./ar": 176,
	"./ar-dz": 170,
	"./ar-dz.js": 170,
	"./ar-kw": 171,
	"./ar-kw.js": 171,
	"./ar-ly": 172,
	"./ar-ly.js": 172,
	"./ar-ma": 173,
	"./ar-ma.js": 173,
	"./ar-sa": 174,
	"./ar-sa.js": 174,
	"./ar-tn": 175,
	"./ar-tn.js": 175,
	"./ar.js": 176,
	"./az": 177,
	"./az.js": 177,
	"./be": 178,
	"./be.js": 178,
	"./bg": 179,
	"./bg.js": 179,
	"./bm": 180,
	"./bm.js": 180,
	"./bn": 181,
	"./bn.js": 181,
	"./bo": 182,
	"./bo.js": 182,
	"./br": 183,
	"./br.js": 183,
	"./bs": 184,
	"./bs.js": 184,
	"./ca": 185,
	"./ca.js": 185,
	"./cs": 186,
	"./cs.js": 186,
	"./cv": 187,
	"./cv.js": 187,
	"./cy": 188,
	"./cy.js": 188,
	"./da": 189,
	"./da.js": 189,
	"./de": 192,
	"./de-at": 190,
	"./de-at.js": 190,
	"./de-ch": 191,
	"./de-ch.js": 191,
	"./de.js": 192,
	"./dv": 193,
	"./dv.js": 193,
	"./el": 194,
	"./el.js": 194,
	"./en-au": 195,
	"./en-au.js": 195,
	"./en-ca": 196,
	"./en-ca.js": 196,
	"./en-gb": 197,
	"./en-gb.js": 197,
	"./en-ie": 198,
	"./en-ie.js": 198,
	"./en-nz": 199,
	"./en-nz.js": 199,
	"./eo": 200,
	"./eo.js": 200,
	"./es": 203,
	"./es-do": 201,
	"./es-do.js": 201,
	"./es-us": 202,
	"./es-us.js": 202,
	"./es.js": 203,
	"./et": 204,
	"./et.js": 204,
	"./eu": 205,
	"./eu.js": 205,
	"./fa": 206,
	"./fa.js": 206,
	"./fi": 207,
	"./fi.js": 207,
	"./fo": 208,
	"./fo.js": 208,
	"./fr": 211,
	"./fr-ca": 209,
	"./fr-ca.js": 209,
	"./fr-ch": 210,
	"./fr-ch.js": 210,
	"./fr.js": 211,
	"./fy": 212,
	"./fy.js": 212,
	"./gd": 213,
	"./gd.js": 213,
	"./gl": 214,
	"./gl.js": 214,
	"./gom-latn": 215,
	"./gom-latn.js": 215,
	"./gu": 216,
	"./gu.js": 216,
	"./he": 217,
	"./he.js": 217,
	"./hi": 218,
	"./hi.js": 218,
	"./hr": 219,
	"./hr.js": 219,
	"./hu": 220,
	"./hu.js": 220,
	"./hy-am": 221,
	"./hy-am.js": 221,
	"./id": 222,
	"./id.js": 222,
	"./is": 223,
	"./is.js": 223,
	"./it": 224,
	"./it.js": 224,
	"./ja": 225,
	"./ja.js": 225,
	"./jv": 226,
	"./jv.js": 226,
	"./ka": 227,
	"./ka.js": 227,
	"./kk": 228,
	"./kk.js": 228,
	"./km": 229,
	"./km.js": 229,
	"./kn": 230,
	"./kn.js": 230,
	"./ko": 231,
	"./ko.js": 231,
	"./ky": 232,
	"./ky.js": 232,
	"./lb": 233,
	"./lb.js": 233,
	"./lo": 234,
	"./lo.js": 234,
	"./lt": 235,
	"./lt.js": 235,
	"./lv": 236,
	"./lv.js": 236,
	"./me": 237,
	"./me.js": 237,
	"./mi": 238,
	"./mi.js": 238,
	"./mk": 239,
	"./mk.js": 239,
	"./ml": 240,
	"./ml.js": 240,
	"./mr": 241,
	"./mr.js": 241,
	"./ms": 243,
	"./ms-my": 242,
	"./ms-my.js": 242,
	"./ms.js": 243,
	"./my": 244,
	"./my.js": 244,
	"./nb": 245,
	"./nb.js": 245,
	"./ne": 246,
	"./ne.js": 246,
	"./nl": 248,
	"./nl-be": 247,
	"./nl-be.js": 247,
	"./nl.js": 248,
	"./nn": 249,
	"./nn.js": 249,
	"./pa-in": 250,
	"./pa-in.js": 250,
	"./pl": 251,
	"./pl.js": 251,
	"./pt": 253,
	"./pt-br": 252,
	"./pt-br.js": 252,
	"./pt.js": 253,
	"./ro": 254,
	"./ro.js": 254,
	"./ru": 255,
	"./ru.js": 255,
	"./sd": 256,
	"./sd.js": 256,
	"./se": 257,
	"./se.js": 257,
	"./si": 258,
	"./si.js": 258,
	"./sk": 259,
	"./sk.js": 259,
	"./sl": 260,
	"./sl.js": 260,
	"./sq": 261,
	"./sq.js": 261,
	"./sr": 263,
	"./sr-cyrl": 262,
	"./sr-cyrl.js": 262,
	"./sr.js": 263,
	"./ss": 264,
	"./ss.js": 264,
	"./sv": 265,
	"./sv.js": 265,
	"./sw": 266,
	"./sw.js": 266,
	"./ta": 267,
	"./ta.js": 267,
	"./te": 268,
	"./te.js": 268,
	"./tet": 269,
	"./tet.js": 269,
	"./th": 270,
	"./th.js": 270,
	"./tl-ph": 271,
	"./tl-ph.js": 271,
	"./tlh": 272,
	"./tlh.js": 272,
	"./tr": 273,
	"./tr.js": 273,
	"./tzl": 274,
	"./tzl.js": 274,
	"./tzm": 276,
	"./tzm-latn": 275,
	"./tzm-latn.js": 275,
	"./tzm.js": 276,
	"./uk": 277,
	"./uk.js": 277,
	"./ur": 278,
	"./ur.js": 278,
	"./uz": 280,
	"./uz-latn": 279,
	"./uz-latn.js": 279,
	"./uz.js": 280,
	"./vi": 281,
	"./vi.js": 281,
	"./x-pseudo": 282,
	"./x-pseudo.js": 282,
	"./yo": 283,
	"./yo.js": 283,
	"./zh-cn": 284,
	"./zh-cn.js": 284,
	"./zh-hk": 285,
	"./zh-hk.js": 285,
	"./zh-tw": 286,
	"./zh-tw.js": 286
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.1ba2cb0.png";

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ca52b40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(519),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(525),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(524),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(527),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(522),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(521),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(512),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(515),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(520),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(508),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(523),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(514),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(518),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ed6eab4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(513),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "uk-button uk-button-default",
    attrs: {
      "href": ("#image-modal-" + _vm.componentID),
      "uk-toggle": ""
    }
  }, [_vm._v(_vm._s(_vm.multiple ? "Kies foto's" : "Kies foto"))]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-container",
    attrs: {
      "id": ("image-modal-" + _vm.componentID),
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title uk-align-left"
  }, [_vm._v(_vm._s(_vm.multiple ? "Kies foto's" : "Kies foto"))]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.choose($event)
      }
    }
  }, [_vm._v("Kies")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body",
    attrs: {
      "uk-overflow-auto": ""
    }
  }, [_c('div', {
    staticClass: "uk-child-width-1-6@m",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.media), function(m, id) {
    return _c('div', [_c('div', {
      staticClass: "uk-card uk-link uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-media-top"
    }, [_c('img', {
      attrs: {
        "src": m.url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(id, m)
        }
      }
    })]), _vm._v(" "), (_vm.selected[id]) ? _c('div', {
      staticClass: "uk-card-badge uk-label"
    }, [_c('span', {
      attrs: {
        "uk-icon": "check"
      }
    })]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.choose($event)
      }
    }
  }, [_vm._v("Kies")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close"
  }, [_vm._v("Annuleren")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(this.$store.state.core.user) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pages"
    }
  }, [_vm._v("Pagina's")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'PageEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("Bewerk pagina")])], 1)]), _vm._v(" "), _c('h1', [_vm._v("Bewerk Pagina")]), _vm._v(" "), _c('div', [_vm._l((_vm.sections), function(s, id) {
    return _c('div', {
      staticClass: "uk-card uk-card-default uk-card-body uk-margin-small"
    }, [_c('div', {}, [_c('div', {
      staticClass: "uk-align-left"
    }, [_c('p', {
      staticClass: "uk-card-title"
    }, [_vm._v(_vm._s(s.name))])]), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('div', {
      staticClass: "uk-align-right"
    }, [_c('span', {
      staticClass: "uk-link uk-margin",
      attrs: {
        "uk-icon": "icon: trash; ratio: 1"
      },
      on: {
        "click": function($event) {
          _vm.deleteSection(id)
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
      staticClass: "uk-table"
    }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Veldnaam")]), _vm._v(" "), _c('th', [_vm._v("Waarde")]), _vm._v(" "), (_vm.$store.state.core.user.role >= 4) ? _c('th') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((s.fields), function(field, key) {
      return _c('tr', [_c('td', {
        attrs: {
          "width": "30"
        }
      }, [_c('span', {
        staticClass: "uk-link uk-margin",
        attrs: {
          "uk-toggle": "",
          "href": "#field-modal",
          "uk-icon": "icon: pencil; ratio: 1.5"
        },
        on: {
          "click": function($event) {
            _vm.setEdit(id, key, field)
          }
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), (field.type == 'link') ? _c('td', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": field.value.url
        }
      }, [_vm._v(_vm._s(field.value.text))])]) : (!_vm.isImage(field)) ? _c('td', [_vm._v(_vm._s(field.value))]) : _c('td', [_c('vue-image', {
        attrs: {
          "img": field.value,
          "size": 4
        }
      })], 1), _vm._v(" "), (_vm.$store.state.core.user.role >= 4) ? _c('td', {
        attrs: {
          "width": "30"
        }
      }, [_c('span', {
        staticClass: "uk-link uk-margin",
        attrs: {
          "uk-icon": "icon: trash; ratio: 1.2"
        },
        on: {
          "click": function($event) {
            _vm.deleteField(id, key)
          }
        }
      })]) : _vm._e()])
    }))]), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('div', {
      staticClass: "uk-placeholder uk-text-center uk-link",
      attrs: {
        "href": "#field-modal",
        "uk-toggle": ""
      },
      on: {
        "click": function($event) {
          _vm.setSelectedSection(id)
        }
      }
    }, [_c('span', {
      staticClass: "uk-padding-small",
      attrs: {
        "uk-icon": "icon: plus; ratio: 1"
      }
    }), _vm._v("VOEG VELD TOE")]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "uk-text-primary uk-divider-icon"
    })])
  }), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('div', {
    staticClass: "uk-placeholder uk-text-center uk-link",
    attrs: {
      "href": "#section-modal",
      "uk-toggle": ""
    }
  }, [_c('span', {
    staticClass: "uk-padding-small",
    attrs: {
      "uk-icon": "icon: plus; ratio: 1"
    }
  }), _vm._v("VOEG SECTIE TOE")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "section-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection),
      expression: "newSection"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newSection)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSection = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Toevoegen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close"
  }, [_vm._v("Annuleren")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "field-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-header"
  }, [(_vm.editing) ? _c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Veld bewerken")]) : _c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Veld toevoegen")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [(!_vm.editing) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.name),
      expression: "newField.name"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newField.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "name", $event.target.value)
      }
    }
  }) : _c('h3', [_vm._v(_vm._s(_vm.newField.name))])]), _vm._v(" "), (!_vm.editing) ? _c('ul', {
    attrs: {
      "uk-tab": ""
    }
  }, [_c('li', {
    staticClass: "uk-active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.selectCurrentType('text')
      }
    }
  }, [_vm._v("Tekst")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.selectCurrentType('img')
      }
    }
  }, [_vm._v("Afbeelding")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.selectCurrentType('link')
      }
    }
  }, [_vm._v("Link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.selectCurrentType('wysiwyg')
      }
    }
  }, [_vm._v("WYSIWYG")])])]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('div', [(_vm.currentType == 'text') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value),
      expression: "newField.value"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "value", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentType == 'img') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('image-picker', {
    on: {
      "choose": _vm.choose
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentType == 'link') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value.text),
      expression: "newField.value.text"
    }],
    staticClass: "uk-input uk-margin",
    attrs: {
      "type": "text",
      "placeholder": "Link tekst"
    },
    domProps: {
      "value": (_vm.newField.value.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField.value, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value.url),
      expression: "newField.value.url"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.newField.value.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField.value, "url", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentType == 'wysiwyg') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('Vueditor', {
    ref: "editor"
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', [(_vm.newField.type == 'link') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value.text),
      expression: "newField.value.text"
    }],
    staticClass: "uk-input uk-margin",
    attrs: {
      "type": "text",
      "placeholder": "Link tekst"
    },
    domProps: {
      "value": (_vm.newField.value.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField.value, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value.url),
      expression: "newField.value.url"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.newField.value.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField.value, "url", $event.target.value)
      }
    }
  })]) : (typeof _vm.newField.value == 'object' || typeof _vm.newField.value == 'array') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('vue-image', {
    attrs: {
      "img": _vm.newField.value
    }
  }), _vm._v(" "), _c('image-picker', {
    staticClass: "uk-margin",
    attrs: {
      "multiple": typeof _vm.newField.value == 'array'
    },
    on: {
      "choose": _vm.choose
    }
  })], 1) : (_vm.newField.type == 'wysiwyg') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('Vueditor', {
    ref: "editor"
  })], 1) : _c('div', {
    staticClass: "uk-margin"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value),
      expression: "newField.value"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "value", $event.target.value)
      }
    }
  })])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [(_vm.editing) ? _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editField($event)
      }
    }
  }, [_vm._v("Bewerken")]) : _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addField($event)
      }
    }
  }, [_vm._v("Toevoegen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuleren")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Sectie toevoegen")])])
}]}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(_vm.u) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Gebruikers")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserDetail',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.u.displayName))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "uk-align-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserEdit',
        params: {
          id: _vm.$route.params.id
        }
      },
      "uk-icon": "icon: pencil; ratio: 2"
    }
  })], 1), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(_vm.u.displayName))]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-1"
  }, [_c('img', {
    staticClass: "round",
    attrs: {
      "src": _vm.u.photoURL
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('p', [_c('span', {
    staticClass: "uk-padding-small",
    attrs: {
      "uk-icon": "icon: mail"
    }
  }), _vm._v(_vm._s(_vm.u.email))])]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [(_vm.u.facebookLinked) ? _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-success",
    attrs: {
      "uk-icon": "icon: check"
    }
  }), _vm._v("Linked with Facebook")]) : _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-danger",
    attrs: {
      "uk-icon": "icon: close"
    }
  }), _vm._v("Not linked with Facebook")])]), _c('div', {
    staticClass: "uk-margin"
  }, [(!_vm.u.firstLogin) ? _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-success",
    attrs: {
      "uk-icon": "icon: check"
    }
  }), _vm._v("Activated")]) : _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-danger",
    attrs: {
      "uk-icon": "icon: close"
    }
  }), _vm._v("Inactive")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "uk-margin",
    attrs: {
      "uk-margin": ""
    }
  }, [_c('div', {
    attrs: {
      "uk-form-custom": "target: true"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.select
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "uk-input uk-form-width-medium",
    attrs: {
      "type": "text",
      "placeholder": "Kies Afbeeldingen",
      "disabled": ""
    }
  })])]), _vm._v(" "), _vm._l((_vm.files), function(f, i) {
    return (_vm.loaded[0 + i] != 100) ? _c('div', [_c('p', {
      staticClass: "uk-text-muted"
    }, [_vm._v(_vm._s(f.name))]), _vm._v(" "), _c('progress', {
      staticClass: "uk-progress",
      attrs: {
        "id": "js-progressbar",
        "max": "100"
      },
      domProps: {
        "value": _vm.loaded[0 + i]
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.URLS), function(img, i) {
    return (_vm.showForm) ? _c('div', {
      staticClass: "uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin",
      attrs: {
        "uk-grid": ""
      }
    }, [_c('div', {
      staticClass: "uk-card-media-left uk-cover-container"
    }, [_c('img', {
      attrs: {
        "src": img.url,
        "alt": "",
        "uk-cover": ""
      }
    }), _vm._v(" "), _c('canvas', {
      attrs: {
        "width": "600",
        "height": "400"
      }
    })]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "uk-card-body"
    }, [_c('h3', {
      staticClass: "uk-card-title"
    }, [_vm._v("Afbeelding Info")]), _vm._v(" "), _c('form', [_c('div', {
      staticClass: "uk-margin"
    }, [_c('label', {
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Titel")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.title),
        expression: "img.title"
      }],
      staticClass: "uk-input",
      attrs: {
        "id": "title",
        "name": "title",
        "type": "text",
        "palceholder": "title"
      },
      domProps: {
        "value": (img.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(img, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-margin"
    }, [_c('label', {
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Alt")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.alt),
        expression: "img.alt"
      }],
      staticClass: "uk-input",
      attrs: {
        "id": "title",
        "name": "alt",
        "type": "text",
        "palceholder": "alt"
      },
      domProps: {
        "value": (img.alt)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(img, "alt", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-margin"
    }, [_c('label', {
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Caption")]), _c('br'), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.caption),
        expression: "img.caption"
      }],
      staticClass: "uk-input",
      attrs: {
        "id": "title",
        "name": "caption",
        "type": "text",
        "palceholder": "caption"
      },
      domProps: {
        "value": (img.caption)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(img, "caption", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-margin"
    }, [_c('label', {
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Beschrijving")]), _c('br'), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.description),
        expression: "img.description"
      }],
      staticClass: "uk-input",
      attrs: {
        "id": "title",
        "name": "description",
        "type": "text",
        "palceholder": "Beschrijving"
      },
      domProps: {
        "value": (img.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(img, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-margin"
    }, [_c('button', {
      staticClass: "uk-button uk-button-primary uk-align-left",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.saveInfo(i)
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), (_vm.status[i]) ? _c('p', [_vm._v(_vm._s(_vm.status[i]))]) : _vm._e()])])])])]) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'uk-child-width-1-' + _vm.size + '@m',
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.images), function(i) {
    return _c('div', [_c('img', {
      attrs: {
        "src": i.url,
        "alt": i.alt,
        "title": i.title
      }
    })])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "uk-navbar-container",
    attrs: {
      "uk-navbar": ""
    }
  }, [_c('div', {
    staticClass: "uk-navbar-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "navlogo pb-2",
    attrs: {
      "src": __webpack_require__(485)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "uk-navbar-nav"
  }, [_c('li', {
    staticClass: "uk-margin-small-left uk-visible@s"
  }, [_vm._v(_vm._s(_vm.$store.state.core.config.generalData.displayName || ''))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-navbar-right"
  }, [_c('ul', {
    staticClass: "uk-navbar-nav"
  }, [_c('li', [(_vm.$store.state.core.user) ? _c('div', {
    staticClass: "uk-inline"
  }, [_c('div', [_c('img', {
    staticClass: "round uk-margin-small-right",
    attrs: {
      "src": _vm.$store.state.core.user.photoURL,
      "width": "40"
    }
  }), _c('span', {
    staticClass: "uk-visible@m uk-margin-small-right"
  }, [_vm._v(_vm._s(_vm.$store.state.core.user.displayName))])]), _vm._v(" "), _c('div', {
    attrs: {
      "uk-dropdown": "pos: bottom-justify"
    }
  }, [_c('ul', {
    staticClass: "uk-nav uk-dropdown-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "profile"
    }
  }, [_vm._v("Profiel")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "uk-text-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("Afmelden")])])])])]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page bg-primary"
  }, [(_vm.loggedIn) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Kies een Wachtwoord")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "name": "newPassword",
      "placeholder": "Nieuw Wachtwoord"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-alert-danger"
  }, [_vm._v(_vm._s(_vm.error.code))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ChangePassword($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("TOEPASSEN")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.warning) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Er ging iets fout")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [(_vm.$store.state.core.user) ? _c('p', [_vm._v("Je hebt je account nog niet geactiveerd. "), _c('br'), _vm._v(" Dit kan met de link die we naar " + _vm._s(_vm.$store.state.core.user.email) + " hebben verzonden.")]) : _c('p', [_vm._v("Je hebt je account nog niet geactiveerd. "), _c('br'), _vm._v(" Dit kan met de link die we naar je email-adress hebben verzonden.")])]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ChangeAccount($event)
      }
    }
  }, [_vm._v("Ander account")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Er ging iets fout")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ChangeAccount($event)
      }
    }
  }, [_vm._v("Ander account")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-margin"
  }, [_c('p', {
    staticClass: "uk-text-danger"
  }, [_vm._v("De link die je hebt gebruikt is niet correct. "), _c('br'), _vm._v(" Gebruik de link die je ontvangen hebt via email.")])])
}]}

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(_vm.project) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("Projecten")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ProjectEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.project.name))])], 1)]), _vm._v(" "), _c('h1', [_vm._v("Project: " + _vm._s(_vm.project.name))]), _vm._v(" "), _c('div', [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.name),
      expression: "project.name"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Projectnaam"
    },
    domProps: {
      "value": (_vm.project.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.info),
      expression: "project.info"
    }],
    staticClass: "uk-input",
    attrs: {
      "placeholder": "Project Info"
    },
    domProps: {
      "value": (_vm.project.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "info", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.category),
      expression: "project.category"
    }],
    staticClass: "uk-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categories), function(c) {
    return _c('option', [_vm._v(_vm._s(c))])
  }))]), _vm._v(" "), _c('image-picker', {
    staticClass: "uk-margin",
    on: {
      "choose": _vm.choose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-child-width-1-4@m",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.project.gallery), function(g, i) {
    return _c('div', [_c('div', {
      staticClass: "uk-card uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-media-top"
    }, [_c('img', {
      attrs: {
        "src": g.small || g.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(g.description))])]), _vm._v(" "), _c('span', {
      staticClass: "uk-card-badge uk-label uk-label-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeImage(i)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Updaten")]) : _vm._e(), (_vm.loading) ? _c('span', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])], 1)])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Gebruikers")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(u, id) {
    return _c('tr', [_c('td', [(u.photoURL) ? _c('img', {
      staticClass: "round",
      attrs: {
        "width": "30",
        "src": u.photoURL
      }
    }) : _c('span', {
      attrs: {
        "uk-icon": "icon: user; ratio: 1.2"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.displayName))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + u.email
      }
    }, [_vm._v(_vm._s(u.email))])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'tel:' + u.phone
      }
    }, [_vm._v(_vm._s(u.phone))])]), _vm._v(" "), (_vm.roles && _vm.roles[id]) ? _c('td', [_vm._v(_vm._s(_vm.userRoles[_vm.roles[id].role - 1]))]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.roles[id.role < 4] || _vm.$store.state.core.user.role >= 4) ? _c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    }) : _vm._e()], 1)])
  }))])]), _vm._v(" "), (Object.keys(_vm.newUsers).length > 0 && _vm.newUsers.constructor === Object) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('h4', [_vm._v("Gebruikers worden toegevoegd")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.newUsers), function(u, id) {
    return _c('tr', [_vm._m(4, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.firstname + ' ' + u.lastname))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + u.email
      }
    }, [_vm._v(_vm._s(u.email))])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'tel:' + u.phone
      }
    }, [_vm._v(_vm._s(u.phone))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.error))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "invite-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvite.firstname),
      expression: "newInvite.firstname"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Voornaam"
    },
    domProps: {
      "value": (_vm.newInvite.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInvite, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvite.lastname),
      expression: "newInvite.lastname"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newInvite.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInvite, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvite.email),
      expression: "newInvite.email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newInvite.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInvite, "email", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.invite($event)
      }
    }
  }, [_vm._v("Uitnodigen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Annuleren")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Gebruikers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-align-right"
  }, [_c('a', {
    attrs: {
      "href": "#invite-modal",
      "uk-toggle": "",
      "uk-icon": "icon: plus; ratio: 2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("gsm")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }, [_vm._v("Rol")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("gsm")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    attrs: {
      "uk-spinner": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Gebruiker uitnodigen")])])
}]}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page bg-primary"
  }, [_c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("LOGIN")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "name": "username",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-alert-danger uk-margin"
  }, [_vm._v(_vm._s(_vm.errorMessages[_vm.error.code] || _vm.error.code || _vm.error))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("AANMELDEN")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('a', {
    staticClass: "uk-button uk-button-primary .uk-width-1-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loginFb()
      }
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: facebook"
    }
  }), _vm._v("Aanmelden met Facebook")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "wachtwoord-vergeten"
    }
  }, [_vm._v("Wachtwoord Vergeten?")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.projects), function(p, id) {
    return _c('tr', [_vm._m(1, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.category))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.convertDate(p.lastEdit)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'ProjectEdit',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    })], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "uk-link",
      attrs: {
        "uk-icon": "icon: trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(id)
        }
      }
    })])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Tijdstip")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    attrs: {
      "uk-icon": "icon: bolt; ratio: 1.2"
    }
  })])
}]}

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "app"
    }
  }, [(_vm.$store.state.core.loading) ? _c('div', {
    staticClass: "preloader"
  }, [_c('svg', {
    staticClass: "spinner",
    attrs: {
      "viewBox": "0 0 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "20",
      "fill": "none",
      "stroke-width": "5"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.core.loading && _vm.$store.state.core.user && !_vm.$store.state.core.user.firstLogin) ? _c('app-header') : _vm._e(), _vm._v(" "), (!_vm.$store.state.core.loading && _vm.$store.state.core.user && !_vm.$store.state.core.user.firstLogin) ? _c('side-menu', {
    staticClass: "side-menu"
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.core.loading) ? _c('router-view', {
    on: {
      "loading": _vm.toggleLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidemenu"
  }, [(this.$store.state.core.user) ? _c('ul', {
    staticClass: "uk-list"
  }, [(_vm.$store.state.core.user.role >= 4) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/configuratie"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: cog"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Configuratie")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: users"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Gebruikers")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/media"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Gallerij")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pages"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: copy"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Pagina's")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: bolt"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Projects")])])], 1)]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "bottom-logo",
    attrs: {
      "src": __webpack_require__(486)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bottom-version"
  }, [_vm._v(_vm._s(_vm.$store.state.core.version))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/blog"
    }
  }, [_vm._v("Blog")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'EditBlogPost',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("Blog " + _vm._s(_vm.editing ? 'bewerken' : 'maken'))])], 1)]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.blog.title))]), _vm._v(" "), _c('div', [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blog.title),
      expression: "blog.title"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Blog Titel"
    },
    domProps: {
      "value": (_vm.blog.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blog, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blog.online),
      expression: "blog.online"
    }],
    staticClass: "uk-input uk-checkbox",
    attrs: {
      "type": "checkbox",
      "placeholder": "Beschikbaar"
    },
    domProps: {
      "checked": Array.isArray(_vm.blog.online) ? _vm._i(_vm.blog.online, null) > -1 : (_vm.blog.online)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.blog.online,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.blog.online = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.blog.online = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.blog, "online", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Openbaar")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory),
      expression: "newCategory"
    }],
    staticClass: "uk-select uk-form-width-medium",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.categories), function(c, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(c))])
  })), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addCategory($event)
      }
    }
  }, [_vm._v("toevoegen")])]), _vm._v(" "), (Object.keys(_vm.blog.categories).length > 0) ? _c('div', {
    staticClass: "uk-margin"
  }, _vm._l((_vm.blog.categories), function(c, k) {
    return _c('div', {
      staticClass: "uk-column-span"
    }, [_c('p', {
      staticClass: "uk-align-left"
    }, [_vm._v(_vm._s(c))]), _vm._v(" "), _c('button', {
      staticClass: "uk-align-right uk-label uk-label-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeCategory(k)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('Vueditor', {
    ref: "editor"
  })], 1), _vm._v(" "), _c('image-picker', {
    staticClass: "uk-margin-bottom",
    on: {
      "choose": _vm.choose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-child-width-1-4@m",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.blog.gallery), function(g, i) {
    return _c('div', [_c('div', {
      staticClass: "uk-card uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-media-top"
    }, [_c('img', {
      attrs: {
        "src": g.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(g.description))])]), _vm._v(" "), _c('button', {
      staticClass: "uk-card-badge uk-label uk-label-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeImage(i)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.editing ? 'updaten' : 'toevoegen'))])], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.core.user) ? _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('img', {
    staticClass: "round",
    attrs: {
      "src": _vm.$store.state.core.user.photoURL
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$store.state.core.user.displayName))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.$store.state.core.user.photoUrl
    }
  }), _vm._v(" "), (!_vm.$store.state.core.user.facebookLinked) ? _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-danger",
    attrs: {
      "uk-icon": "icon: close"
    }
  }), _vm._v("Not linked with Facebook")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.core.user.facebookLinked) ? _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-success",
    attrs: {
      "uk-icon": "icon: check"
    }
  }), _vm._v("Linked with Facebook")]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.core.user.facebookLinked) ? _c('button', {
    staticClass: "uk-button uk-button-primary",
    on: {
      "click": _vm.linkFacebook
    }
  }, [_vm._v("LINK WITH FACEBOOK")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "uk-button uk-button-secondary",
    attrs: {
      "to": "wachtwoord-veranderen"
    }
  }, [_vm._v("Wachtwoord Veranderen")]), _vm._v(" "), _c('ul', _vm._l((_vm.$store.state.core.user.moni), function(u) {
    return _c('li', [_vm._v(_vm._s(u))])
  })), _vm._v(" "), _c('ul', _vm._l((_vm.$store.state.core.user.vv), function(u) {
    return _c('li', [_vm._v(_vm._s(u))])
  }))], 1)]) : _c('div', [_vm._v("\nLoading..\n")])
},staticRenderFns: []}

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(_vm.preferences && _vm.preferences.generalData) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('h1', [_vm._v("Algemene Instellingen")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Naam")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.displayName),
      expression: "preferences.generalData.displayName"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Bedrijfsnaam"
    },
    domProps: {
      "value": (_vm.preferences.generalData.displayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "displayName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Website Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.websiteLink),
      expression: "preferences.generalData.websiteLink"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Website Link"
    },
    domProps: {
      "value": (_vm.preferences.generalData.websiteLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "websiteLink", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Signup Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.signupPrefix),
      expression: "preferences.generalData.signupPrefix"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Signup Link"
    },
    domProps: {
      "value": (_vm.preferences.generalData.signupPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "signupPrefix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Contact Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.contactEmail),
      expression: "preferences.generalData.contactEmail"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Contact Email"
    },
    domProps: {
      "value": (_vm.preferences.generalData.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "contactEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("No Reply Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.noReplyEmail),
      expression: "preferences.generalData.noReplyEmail"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "No Reply Email"
    },
    domProps: {
      "value": (_vm.preferences.generalData.noReplyEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "noReplyEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Sendgrid Account Created Template")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.accountCreatedTemplate),
      expression: "preferences.generalData.accountCreatedTemplate"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Sendgrid Template ID"
    },
    domProps: {
      "value": (_vm.preferences.generalData.accountCreatedTemplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "accountCreatedTemplate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Sendgrid Contect Form Template")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.contactedTemplate),
      expression: "preferences.generalData.contactedTemplate"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Sendgrid Template ID"
    },
    domProps: {
      "value": (_vm.preferences.generalData.contactedTemplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "contactedTemplate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.update
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Save")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page bg-primary"
  }, [(!_vm.success) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Wachtwoord Veranderen")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "name": "email",
      "placeholder": "Oud Wachtwoord"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "name": "email",
      "placeholder": "Nieuw Wachtwoord"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-alert-danger"
  }, [_vm._v(_vm._s(_vm.error.code))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ChangePassword($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("AANPASSEN")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Wachtwoord veranderd!")]), _vm._v(" "), _c('router-link', {
    staticClass: "uk-button uk-button-primary",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Klaar!")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(_vm.u) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Gebruikers")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserDetail',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.u.displayName))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("Bewerken")])], 1)]), _vm._v(" "), _c('h1', [_vm._v("Gegevens Bewerken")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u.displayName),
      expression: "u.displayName"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Volledige naam"
    },
    domProps: {
      "value": (_vm.u.displayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.u, "displayName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u.firstname),
      expression: "u.firstname"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Voornaam"
    },
    domProps: {
      "value": (_vm.u.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.u, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u.lastname),
      expression: "u.lastname"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.u.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.u, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u.email),
      expression: "u.email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.u.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.u, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role),
      expression: "role"
    }],
    staticClass: "uk-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.role = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.userRoles), function(r, i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(r))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary",
    on: {
      "click": _vm.update
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Save")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('h1', [_vm._v("Foto's")]), _vm._v(" "), _c('imageUploader'), _vm._v(" "), _c('div', {
    staticClass: "uk-child-width-1-4@m",
    attrs: {
      "uk-grid": ""
    }
  }, [_vm._l((_vm.media), function(m, id) {
    return (!m.processed && !m.error) ? _c('div', [_c('div', {
      staticClass: "uk-card uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-body"
    }, [_c('div', {
      staticClass: "spinner-container"
    }, [_c('svg', {
      staticClass: "spinner spinner-dark",
      attrs: {
        "viewBox": "0 0 50 50"
      }
    }, [_c('circle', {
      staticClass: "path",
      attrs: {
        "cx": "25",
        "cy": "25",
        "r": "20",
        "fill": "none",
        "stroke-width": "5"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })]), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('div', {
      staticClass: "uk-card-badge uk-label",
      class: 'uk-label-danger',
      on: {
        "click": function($event) {
          _vm.deleteProcessingImage(id)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.media), function(m, id) {
    return (m.processed & !m.error) ? _c('div', [_c('a', {
      attrs: {
        "href": "#image-edit",
        "uk-toggle": ""
      },
      on: {
        "click": function($event) {
          _vm.select(id)
        }
      }
    }, [_c('div', {
      staticClass: "uk-card uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-media-top"
    }, [_c('img', {
      attrs: {
        "src": m.small,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-card-badge uk-label",
      class: (m.placeholder && m.small && m.medium && m.large && m.extralarge) ? 'uk-label-success' : 'uk-label-danger'
    }, [_c('span', {
      attrs: {
        "uk-icon": "check"
      }
    })])])])]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "image-edit",
      "uk-modal": ""
    }
  }, [(_vm.selected) ? _c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('div', {
    staticClass: "uk-align-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.media[_vm.selected].small
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer uk-text-right"
  }, [(_vm.$store.state.core.user.role >= 3) ? _c('button', {
    staticClass: "uk-button uk-button-danger uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteImage(_vm.selected)
      }
    }
  }, [_vm._v("Verwijderen")]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Afbeelding bewerken")])])
}]}

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/blog"
    }
  }, [_vm._v("Blog")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Blog")]), _vm._v(" "), _c('div', {
    staticClass: "uk-align-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'EditBlogPost',
        params: {
          id: 0
        }
      },
      "uk-toggle": "",
      "uk-icon": "icon: plus; ratio: 2"
    }
  })], 1), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.blogposts), function(p, id) {
    return _c('tr', [_vm._m(1, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.title))]), _vm._v(" "), (p.category) ? _c('td', [_vm._v(_vm._s(p.category))]) : (p.categories) ? _c('td', _vm._l((p.categories), function(c) {
      return _c('span', [_vm._v(_vm._s(c) + " - ")])
    })) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.convertDate(p.lastEdit)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'EditBlogPost',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    })], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "uk-link",
      attrs: {
        "uk-icon": "icon: trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(id)
        }
      }
    })])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Categorie")]), _vm._v(" "), _c('th', [_vm._v("Laatste update")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    attrs: {
      "uk-icon": "icon: bolt; ratio: 1.2"
    }
  })])
}]}

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page bg-primary"
  }, [(!_vm.success) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Geef je emailadres in")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Uw Emailadres"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-alert-danger"
  }, [_vm._v(_vm._s(_vm.error.code))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ForgotPassword($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("VERZENDEN")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Aanmelden")])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Email verzonden!")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pages"
    }
  }, [_vm._v("Pagina's")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Pagina's")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pages), function(p, id) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.convertDate(p.lastEdit)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'PageEdit',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    })], 1)])
  }))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPage.name),
      expression: "newPage.name"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newPage.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPage, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.add($event)
      }
    }
  }, [_vm._v("Uitnodigen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuleren")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-align-right"
  }, [_c('a', {
    attrs: {
      "href": "#page-modal",
      "uk-toggle": "",
      "uk-icon": "icon: plus; ratio: 2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Laatste update")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    attrs: {
      "uk-icon": "icon: copy; ratio: 1.2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Pagina maken")])])
}]}

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("Projecten")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Projecten")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.projects), function(p, id) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.name))]), _vm._v(" "), (p.category) ? _c('td', [_vm._v(_vm._s(p.category))]) : (p.categories) ? _c('td', _vm._l((p.categories), function(c) {
      return _c('span', [_vm._v(_vm._s(c) + " - ")])
    })) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.convertDate(p.lastEdit)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'ProjectEdit',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    })], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "uk-link",
      attrs: {
        "uk-icon": "icon: trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(id)
        }
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.name),
      expression: "newProject.name"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Projectnaam"
    },
    domProps: {
      "value": (_vm.newProject.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.title),
      expression: "newProject.title"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Titel"
    },
    domProps: {
      "value": (_vm.newProject.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('Vueditor', {
    ref: "editor"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.link.url),
      expression: "newProject.link.url"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Link"
    },
    domProps: {
      "value": (_vm.newProject.link.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject.link, "url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.link.text),
      expression: "newProject.link.text"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Link Text"
    },
    domProps: {
      "value": (_vm.newProject.link.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject.link, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.color),
      expression: "newProject.color"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Project Kleur (hex)"
    },
    domProps: {
      "value": (_vm.newProject.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject, "color", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory),
      expression: "newCategory"
    }],
    staticClass: "uk-select uk-form-width-medium",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.categories), function(c, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(c))])
  })), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addCategory($event)
      }
    }
  }, [_vm._v("toevoegen")])]), _vm._v(" "), (Object.keys(this.newProject.categories).length > 0) ? _c('div', {
    staticClass: "uk-margin"
  }, _vm._l((this.newProject.categories), function(c, key) {
    return _c('div', {
      staticClass: "uk-column-span"
    }, [_c('p', {
      staticClass: "uk-align-left"
    }, [_vm._v(_vm._s(c))]), _vm._v(" "), _c('button', {
      staticClass: "uk-align-right uk-label uk-label-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeCategory(key)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('image-picker', {
    on: {
      "choose": _vm.choose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('vue-image', {
    attrs: {
      "img": _vm.newProject.gallery
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.add($event)
      }
    }
  }, [_vm._v("Toevoegen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuleren")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-align-right"
  }, [_c('a', {
    attrs: {
      "href": "#page-modal",
      "uk-toggle": "",
      "uk-icon": "icon: plus; ratio: 2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Categorie")]), _vm._v(" "), _c('th', [_vm._v("Laatste update")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    attrs: {
      "uk-icon": "icon: bolt; ratio: 1.2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Project maken")])])
}]}

/***/ })

},[411]);


// WEBPACK FOOTER //
// static/js/app.5509b441bb612c39b401.js